import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = '/api';

export const expenseCategoryApi = createApi({
  
  reducerPath: 'expenseCategoryApi',
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
      AddExpenseCategory : builder.mutation({
      query: ({ledger, Token}) => ({
        url: `/admin/expense-category`,
        method: 'POST',
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body : {ledger : ledger}
      }),
     // Use 'Projects' for invalidatesTags
     invalidatesTags: ['expances',"expCat"],
    }),
    getExpenseCategory : builder.query({
        query: (Token) => ({
          url: `/admin/expense-category`,
          method: 'GET',
          headers: {
            Authorization: `Bearer ${Token}`,
          }
        }),
       // Use 'Projects' for invalidatesTags
       providesTags : ['expCat'],
       invalidatesTags: ['expances'],
       
      }),
      delExpenseCategory : builder.mutation({
        query: ({Token , Id}) => ({
          url: `/admin/expense-category/${Id}`,
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${Token}`,
          }
        }),
       invalidatesTags: ['expances','expCat'],
       
      })
  }),

});

export const {useAddExpenseCategoryMutation , useGetExpenseCategoryQuery , useDelExpenseCategoryMutation
} = expenseCategoryApi;
